(async () => {
    const { Core } = await importModule('Core');
    const { 
        fetchHTML, 
        $clone,
    } = await importModule('Utils');

    const RQ_SECTION_ID = 'r_cart-drawer';
    const SEL_X_CART = 'x-cart';
    const SEL_MODAL_CONTENT = '[data-modal-content]';
    const CN_OPEN = '!open';
    const CN_NO_SCROLL = 'no-scroll';

    customElements.define('cart-drawer', class extends Core {
        subscriptions = {
            'drawer:open':  '_open',
            'modal:open':  '_close',
            'cart:update':  '_open',
        }

        elements = {
            template: '[data-template]',
            close: '[data-close]',
            backdrop: '[data-backdrop]'
        }

        inited = false;

        render() {
            this.subscribe('drawer:open', { global: true });
            this.subscribe('cart:update', { global: true });
            this.subscribe('modal:open', { global: true });
            this._initContainer()
            this._setCartContent()
            this.$close.addEventListener('click', this._close.bind(this));
            this.$backdrop.addEventListener('click', this._close.bind(this));
        }

        _close(){
            this.classList.remove(CN_OPEN);
            document.body.classList.remove(CN_NO_SCROLL);
        }

        _initContainer() {
            this.$container = $clone(this.$template).querySelector(SEL_MODAL_CONTENT);
        }

        async _setCartContent() {
            const $doc = await fetchHTML(`/?section_id=${RQ_SECTION_ID}`);
            this.$container.appendChild($doc.querySelector(SEL_X_CART));
            this.$template.replaceWith(this.$container);
        }
        
        _open(props) {
            const isCartTrigger = props?.src.toLowerCase() === 'cart-qty-button' || props?.src.toLowerCase() === 'cart-qty-input';
            if(!isCartTrigger) {
                this.classList.add(CN_OPEN);
                document.body.classList.add(CN_NO_SCROLL);
            }
        }
    }) 
})();